const { domainMeta } = require('utils/domainMeta');

const REACT_APP_MONOLITH_BASE_URL = domainMeta.monolithOrigin;
const REACT_APP_GLOBAL_API_BASE_URL = `${domainMeta.monolithOrigin}/api_self_serve/v1`;
const REACT_APP_GLOBAL_API_BASE_URL_V2 = `${domainMeta.monolithOrigin}/api_self_serve/v2`;
const REACT_APP_LANDING_PAGE_URL = `${domainMeta.monolithOrigin}/users/sign_in`;
const REACT_APP_SIGN_OUT_REDIRECT_URL = `${domainMeta.monolithOrigin}/users/sign_in`;
module.exports = {
  REACT_APP_MONOLITH_BASE_URL,
  REACT_APP_GLOBAL_API_BASE_URL,
  REACT_APP_GLOBAL_API_BASE_URL_V2,
  REACT_APP_LANDING_PAGE_URL,
  REACT_APP_SIGN_OUT_REDIRECT_URL,
  REACT_APP_WX_COPILOT_VERSION: 'v2',
  REACT_APP_WX_COPILOT_RELEASE_CHANNEL:
    process.env.REACT_APP_WX_COPILOT_RELEASE_CHANNEL ||
    (domainMeta.environment === 'prod' ? 'stable' : 'main'),
  REACT_APP_WX_NAVBAR_VERSION: 'v2',
  REACT_APP_WX_NAVBAR_RELEASE_CHANNEL:
    process.env.REACT_APP_WX_NAVBAR_RELEASE_CHANNEL ||
    (domainMeta.environment === 'prod' ? 'stable' : 'main'),
  REACT_APP_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID:
    process.env.REACT_APP_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID ||
    '652f17e244cb56124fa8cf95',
  IMAGE_TAG: process.env.IMAGE_TAG,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_CHARGEBEE_SITE: process.env.REACT_APP_CHARGEBEE_SITE,
  REACT_APP_CLEARBIT_API_BASE_URL: process.env.REACT_APP_CLEARBIT_API_BASE_URL,
  REACT_APP_DATADOG_APPLICATION_ID:
    process.env.REACT_APP_DATADOG_APPLICATION_ID,
  REACT_APP_DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  REACT_APP_DATADOG_SAMPLE_RATE: process.env.REACT_APP_DATADOG_SAMPLE_RATE,
  REACT_APP_DATADOG_SITE: process.env.REACT_APP_DATADOG_SITE,
  REACT_APP_FRANCHISE_API_BASE_URL:
    process.env.REACT_APP_FRANCHISE_API_BASE_URL,
  REACT_APP_LOGGING_MICROSERVICE_AUTH_TOKEN:
    process.env.REACT_APP_LOGGING_MICROSERVICE_AUTH_TOKEN,
  REACT_APP_LOGGING_MICROSERVICE_URL:
    process.env.REACT_APP_LOGGING_MICROSERVICE_URL,
  REACT_APP_FAKER_SEED: process.env.REACT_APP_FAKER_SEED,
  REACT_APP_HIRE_GO_BASE_URL: process.env.REACT_APP_HIRE_GO_BASE_URL,
  REACT_APP_POSTHOG_API_KEY: process.env.REACT_APP_POSTHOG_API_KEY,
  REACT_APP_POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
  REACT_APP_POSTHOG_DEBUG: process.env.REACT_APP_POSTHOG_DEBUG,
};
